import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";

import { useToast } from "../components/toast/ToastProvider";
import PostsForm from "../components/admin/PostsForm";
import PostsList from "../components/admin/PostsList";
import { createPost, deletePost, fetchAllPost, updatePost } from "../service/postsService";
import Main from "../components/admin/Main";

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [deletingId, setDeletingId] = useState(null);
  const loadPosts = async () => {
    try {
      setLoading(true);
      const res = await fetchAllPost();

      setPosts(res);
    } catch (error) {
      toast("Error in fetch Posts", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPosts();
  }, []);

  const handleSave = async (adData) => {
    try {
      const formData = new FormData();
      formData.append("userId", adData.userId);
      formData.append("tags", adData.tags);
      formData.append("title", adData.title);
      formData.append("content", adData.content);
      formData.append("bannerImageUrl", adData.bannerImageUrl)

      // if (adData.bannerImageUrl instanceof File) {
      //   formData.append("bannerImageUrl", adData.bannerImageUrl);
      // }

      if (selectedPost) {
        await updatePost(selectedPost.postId, formData);
        toast("Post Updated", "SUCCESS");
      } else {
        await createPost(formData);
        toast("Post Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedPost(null);
      setViewMode(false);
      await loadPosts();
    } catch (error) {
      toast("Error in save Post", "ERROR");
    }
  };

  const handleEdit = (ad) => {
    setSelectedPost(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedPost(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleDelete = async (postId) => {
    if (window.confirm("Are you sure you want to delete this Post?")) {
      try {
        setDeletingId(postId); 
        await deletePost(postId);
        toast("Post Deleted", "SUCCESS");
        await loadPosts();
      } catch (error) {
        toast("Error deleting Post", "ERROR");
      } finally {
        setDeletingId(null); 
      }
    }
  };

  return (
    <Main>
      <PageContainer
        title="Posts"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedPost(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedPost(null);
            setViewMode(false);
          }}
          headerText={
            viewMode ? "View Post" : selectedPost ? "Edit Post" : "Add Post"
          }
          centered
        >
          <PostsForm
            initialData={selectedPost}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  }, 2000)
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Posts List">
          <PostsList
            posts={posts}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
            deletingId={deletingId}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Posts;
